export default "__VITE_ASSET__l1WV7Se5__"